export default  {
  text_field: "حقل نصي",
  text_area: "حقل نصي طويل",
  selection: "قائمة خيارات",
  radio: "خيارات radio",
  date: "اختيار تاريخ",
};
